import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "step step-5 step-total" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "heading" }, "Summering", -1);
const _hoisted_3 = {
    key: 0,
    class: "title"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("p", null, "Ålder", -1);
const _hoisted_5 = { class: "s-value" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", null, "Civilstånd", -1);
const _hoisted_8 = { class: "s-value" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", null, "Typ av tjänst", -1);
const _hoisted_11 = { class: "s-value" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", null, "Boendeform", -1);
const _hoisted_14 = { class: "s-value" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("p", { class: "title" }, "Medsökande", -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("p", null, "Ålder", -1);
const _hoisted_18 = { class: "s-value" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("p", null, "Civilstånd", -1);
const _hoisted_21 = { class: "s-value" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("p", null, "Typ av tjänst", -1);
const _hoisted_24 = { class: "s-value" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("p", null, "Boendeform", -1);
const _hoisted_27 = { class: "s-value" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("div", { class: "heading is--thin" }, "Inkomster", -1);
const _hoisted_29 = {
    key: 1,
    class: "columns"
};
const _hoisted_30 = {
    key: 0,
    class: "title"
};
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("p", null, "Nettoinkomst/månad", -1);
const _hoisted_32 = { class: "s-value" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("p", null, "Bostadstillägg/månad", -1);
const _hoisted_35 = { class: "s-value" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("p", null, "Överskott av kapital/månad", -1);
const _hoisted_38 = { class: "s-value" };
const _hoisted_39 = { key: 0 };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("p", { class: "title" }, "Medsökande", -1);
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("p", null, "Nettoinkomst/månad", -1);
const _hoisted_42 = { class: "s-value" };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("p", null, "Bostadstillägg/månad", -1);
const _hoisted_45 = { class: "s-value" };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("p", null, "Överskott av kapital/månad", -1);
const _hoisted_48 = { class: "s-value" };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("div", { class: "heading is--thin" }, "Utgifter", -1);
const _hoisted_50 = {
    key: 2,
    class: "columns"
};
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("p", null, "Kostnad för god man/månad", -1);
const _hoisted_52 = { class: "s-value" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("p", null, "Boendekostnad", -1);
const _hoisted_55 = { class: "s-value" };
const _hoisted_56 = { key: 0 };
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("p", null, "Kostnad för god man medsökande/månad", -1);
const _hoisted_58 = { class: "s-value" };
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("p", null, "Boendekostnad", -1);
const _hoisted_61 = { class: "s-value" };
const _hoisted_62 = /*#__PURE__*/ _createElementVNode("div", { class: "heading is--thin" }, "Avgifter", -1);
const _hoisted_63 = { class: "columns" };
const _hoisted_64 = {
    key: 0,
    class: "s-value"
};
const _hoisted_65 = { key: 0 };
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("p", null, "Vald nivå för Medsökande", -1);
const _hoisted_67 = { class: "s-value" };
const _hoisted_68 = /*#__PURE__*/ _createElementVNode("div", { class: "heading is--bold" }, "Uträkning", -1);
const _hoisted_69 = { class: "columns is--cal" };
const _hoisted_70 = {
    key: 0,
    class: "title"
};
const _hoisted_71 = { class: "tooltip-label" };
const _hoisted_72 = /*#__PURE__*/ _createElementVNode("p", null, "Förbehållsbelopp", -1);
const _hoisted_73 = { class: "s-value" };
const _hoisted_74 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("p", null, "Avgiftsutrymme", -1);
const _hoisted_76 = { class: "s-value" };
const _hoisted_77 = { class: "feeToPay" };
const _hoisted_78 = /*#__PURE__*/ _createElementVNode("p", null, "Preliminär avgift vård och omsorg", -1);
const _hoisted_79 = { class: "total" };
const _hoisted_80 = { key: 1 };
const _hoisted_81 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_82 = { class: "tooltip-label" };
const _hoisted_83 = /*#__PURE__*/ _createElementVNode("p", null, "Måltidskostnad", -1);
const _hoisted_84 = { class: "s-value" };
const _hoisted_85 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_86 = { class: "tooltip-label" };
const _hoisted_87 = /*#__PURE__*/ _createElementVNode("p", null, "Hyreskostnad för särskilt boende/äldreboende", -1);
const _hoisted_88 = { class: "s-value" };
const _hoisted_89 = { key: 0 };
const _hoisted_90 = /*#__PURE__*/ _createElementVNode("p", { class: "title" }, "Medsökande", -1);
const _hoisted_91 = /*#__PURE__*/ _createElementVNode("p", null, "Förbehållsbelopp", -1);
const _hoisted_92 = { class: "s-value" };
const _hoisted_93 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_94 = /*#__PURE__*/ _createElementVNode("p", null, "Avgiftsutrymme", -1);
const _hoisted_95 = { class: "s-value" };
const _hoisted_96 = { class: "feeToPay" };
const _hoisted_97 = { key: 0 };
const _hoisted_98 = /*#__PURE__*/ _createElementVNode("p", null, "Preliminär avgift vård och omsorg", -1);
const _hoisted_99 = { class: "total" };
const _hoisted_100 = { key: 0 };
const _hoisted_101 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_102 = { class: "tooltip-label" };
const _hoisted_103 = /*#__PURE__*/ _createElementVNode("p", null, "Måltidskostnad", -1);
const _hoisted_104 = { class: "s-value" };
const _hoisted_105 = /*#__PURE__*/ _createElementVNode("span", { class: "spacer" }, null, -1);
const _hoisted_106 = { class: "tooltip-label" };
const _hoisted_107 = /*#__PURE__*/ _createElementVNode("p", null, "Hyreskostnad för särskilt boende/äldreboende", -1);
const _hoisted_108 = { class: "s-value" };
const _hoisted_109 = { class: "notice" };
const _hoisted_110 = { class: "buttons" };
const _hoisted_111 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon-arrow" }, null, -1);
const _hoisted_112 = { class: "link-title" };
const _hoisted_113 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon-arrow-rotate-left" }, null, -1);
const _hoisted_114 = { class: "link-title" };
const _hoisted_115 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon-print" }, null, -1);
const _hoisted_116 = /*#__PURE__*/ _createElementVNode("span", { class: "link-title" }, "Skriv ut", -1);
const _hoisted_117 = [
    _hoisted_115,
    _hoisted_116
];
import Tooltip from "./Tooltip.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Step5',
    props: {
        calc: {},
        props: {}
    },
    setup(__props) {
        function formatedFee(number) {
            return `${number.toLocaleString('sv-SE')} kr`;
        }
        function printResults() {
            window.print();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                (_ctx.calc.applicant.age)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass({ 'columns': !_ctx.calc.is.single() })
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass({ 'columns is--4': _ctx.calc.is.single() })
                        }, [
                            (!_ctx.calc.is.single())
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Sökande"))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                                _hoisted_4,
                                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.calc.applicant.age?.label), 1),
                                _hoisted_6
                            ]),
                            _createElementVNode("div", null, [
                                _hoisted_7,
                                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.calc.maritalStatus.value?.label), 1),
                                _hoisted_9
                            ]),
                            _createElementVNode("div", null, [
                                _hoisted_10,
                                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.calc.applicant.service?.label), 1),
                                _hoisted_12
                            ]),
                            _createElementVNode("div", null, [
                                _hoisted_13,
                                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.calc.applicant.accommodation?.label), 1)
                            ])
                        ], 2),
                        (_ctx.calc.is.caringForBoth() || _ctx.calc.is.married())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _hoisted_16,
                                _hoisted_17,
                                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.calc.coApplicant.age?.label), 1),
                                _hoisted_19,
                                _hoisted_20,
                                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.calc.maritalStatus.value?.label), 1),
                                (_ctx.calc.is.caringForBoth())
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_22,
                                        _hoisted_23,
                                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.calc.coApplicant.service?.label), 1),
                                        _hoisted_25,
                                        _hoisted_26,
                                        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.calc.coApplicant.accommodation?.label), 1)
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ], 2))
                    : _createCommentVNode("", true),
                _hoisted_28,
                (_ctx.calc.maritalStatus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", null, [
                            (!_ctx.calc.is.single())
                                ? (_openBlock(), _createElementBlock("p", _hoisted_30, "Sökande"))
                                : _createCommentVNode("", true),
                            _hoisted_31,
                            _createElementVNode("p", _hoisted_32, _toDisplayString(formatedFee(_ctx.calc.applicant.netIncome)), 1),
                            _hoisted_33,
                            _hoisted_34,
                            _createElementVNode("p", _hoisted_35, _toDisplayString(formatedFee(_ctx.calc.applicant.allowance)), 1),
                            _hoisted_36,
                            _hoisted_37,
                            _createElementVNode("p", _hoisted_38, _toDisplayString(formatedFee(_ctx.calc.compute.monthlyCapital(_ctx.calc.applicant.capital))), 1)
                        ]),
                        (_ctx.calc.is.caringForBoth() || _ctx.calc.is.married())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _hoisted_40,
                                _hoisted_41,
                                _createElementVNode("p", _hoisted_42, _toDisplayString(formatedFee(_ctx.calc.coApplicant.netIncome)), 1),
                                _hoisted_43,
                                _hoisted_44,
                                _createElementVNode("p", _hoisted_45, _toDisplayString(formatedFee(_ctx.calc.coApplicant.allowance)), 1),
                                _hoisted_46,
                                _hoisted_47,
                                _createElementVNode("p", _hoisted_48, _toDisplayString(formatedFee(_ctx.calc.compute.monthlyCapital(_ctx.calc.coApplicant.capital))), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _hoisted_49,
                (_ctx.calc.maritalStatus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("div", null, [
                            _hoisted_51,
                            _createElementVNode("p", _hoisted_52, _toDisplayString(formatedFee(_ctx.calc.applicant.lawyerCost)), 1),
                            _hoisted_53,
                            _hoisted_54,
                            _createElementVNode("p", _hoisted_55, _toDisplayString(formatedFee(_ctx.calc.compute.rentFee(_ctx.calc.applicant))), 1)
                        ]),
                        (_ctx.calc.is.caringForBoth())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _hoisted_57,
                                _createElementVNode("p", _hoisted_58, _toDisplayString(formatedFee(_ctx.calc.coApplicant.lawyerCost)), 1),
                                _hoisted_59,
                                _hoisted_60,
                                _createElementVNode("p", _hoisted_61, _toDisplayString(formatedFee(_ctx.calc.compute.rentFee(_ctx.calc.coApplicant))), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", null, [
                        _createElementVNode("p", null, [
                            _createTextVNode("Vald nivå "),
                            (!_ctx.calc.is.single())
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("för Sökande")
                                ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        (_ctx.calc.applicant.fee)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(_ctx.calc.applicant.fee?.label), 1))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.calc.is.caringForBoth())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _hoisted_66,
                            _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.calc.coApplicant.fee?.label), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _hoisted_68,
                _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", null, [
                        (!_ctx.calc.is.single())
                            ? (_openBlock(), _createElementBlock("p", _hoisted_70, "Sökande"))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_71, [
                            _hoisted_72,
                            _createVNode(Tooltip, {
                                text: _ctx.calc.TooltipText.reservedAmmount
                            }, null, 8, ["text"])
                        ]),
                        _createElementVNode("p", _hoisted_73, _toDisplayString(formatedFee(_ctx.calc.compute.serviceFee())), 1),
                        _hoisted_74,
                        _hoisted_75,
                        _createElementVNode("p", _hoisted_76, _toDisplayString(formatedFee(_ctx.calc.compute.feeLeftover(_ctx.calc.applicant))), 1),
                        _createElementVNode("div", _hoisted_77, [
                            _hoisted_78,
                            _createElementVNode("p", _hoisted_79, _toDisplayString(formatedFee(_ctx.calc.compute.careFee(_ctx.calc.applicant)) + "/månad"), 1)
                        ]),
                        (_ctx.calc.is.applicantSpecialCare())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                _hoisted_81,
                                _createElementVNode("div", _hoisted_82, [
                                    _hoisted_83,
                                    _createVNode(Tooltip, {
                                        text: _ctx.calc.TooltipText.mealCost
                                    }, null, 8, ["text"])
                                ]),
                                _createElementVNode("p", _hoisted_84, _toDisplayString(formatedFee(_ctx.props.meal_cost_special)), 1),
                                _hoisted_85,
                                _createElementVNode("div", _hoisted_86, [
                                    _hoisted_87,
                                    _createVNode(Tooltip, {
                                        text: _ctx.calc.TooltipText.rentalCost
                                    }, null, 8, ["text"])
                                ]),
                                _createElementVNode("p", _hoisted_88, _toDisplayString(formatedFee(_ctx.calc.applicant.rent)), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.calc.is.caringForBoth())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                            _hoisted_90,
                            _hoisted_91,
                            _createElementVNode("p", _hoisted_92, _toDisplayString(formatedFee(_ctx.calc.coApplicant.service?.value)), 1),
                            _hoisted_93,
                            _hoisted_94,
                            _createElementVNode("p", _hoisted_95, _toDisplayString(formatedFee(_ctx.calc.compute.feeLeftover(_ctx.calc.coApplicant))), 1),
                            _createElementVNode("div", _hoisted_96, [
                                (_ctx.calc.is.caringForBoth())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                        _hoisted_98,
                                        _createElementVNode("p", _hoisted_99, _toDisplayString(formatedFee(_ctx.calc.compute.careFee(_ctx.calc.coApplicant)) + "/månad"), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            (_ctx.calc.is.coApplicantSpecialCare())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                    _hoisted_101,
                                    _createElementVNode("div", _hoisted_102, [
                                        _hoisted_103,
                                        _createVNode(Tooltip, {
                                            text: _ctx.calc.TooltipText.mealCost
                                        }, null, 8, ["text"])
                                    ]),
                                    _createElementVNode("p", _hoisted_104, _toDisplayString(formatedFee(_ctx.props.meal_cost_special)), 1),
                                    _hoisted_105,
                                    _createElementVNode("div", _hoisted_106, [
                                        _hoisted_107,
                                        _createVNode(Tooltip, {
                                            text: _ctx.calc.TooltipText.rentalCost
                                        }, null, 8, ["text"])
                                    ]),
                                    _createElementVNode("p", _hoisted_108, _toDisplayString(formatedFee(_ctx.calc.coApplicant.rent)), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.calc.props.notice_text), 1)
                ]),
                _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("button", {
                        class: "link linkIcon",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.calc.gotoStep(_ctx.calc.Step.IncomeAndExpenditure, true)))
                    }, [
                        _hoisted_111,
                        _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.calc.ButtonStrings.back), 1)
                    ]),
                    _createElementVNode("button", {
                        class: "link linkIcon",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.calc.resetForm()))
                    }, [
                        _hoisted_113,
                        _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.calc.ButtonStrings.reset), 1)
                    ]),
                    _createElementVNode("button", {
                        class: "link linkIcon",
                        onClick: _cache[2] || (_cache[2] = ($event) => (printResults()))
                    }, _hoisted_117)
                ])
            ]));
        };
    }
});
